'use client';
import React from "react";
import "../../contents/scss/faq.scss";

function Faq({ index, item, id }) {
    const [isOpen, setIsOpen] = React.useState(false);

    return (
        <div
            className="accordion-item"
            key={index}>
            <h2
                className="accordion-header"
                id={`heading-${index}`}>
                <button
                    className={`accordion-button ${isOpen ? '' : 'collapsed'}`}
                    onClick={() => setIsOpen(!isOpen)}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse-${index}`}
                    aria-expanded="true"
                    aria-controls={`collapse-${index}`}>
                    {item.heading}
                </button>
            </h2>
            <div
                id={`collapse-${index}`}
                className={`accordion-collapse collapse t-transition-all t-duration-300 ${isOpen ? 'show t-opacity-100' : 't-opacity-0'}`}
                aria-labelledby={`heading-${index}`}
                data-bs-parent={id} 
            >
                <div className="accordion-body">
                    <p>{item.description}</p>
                </div>
            </div>
        </div>
    );
}

export default Faq;
